import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { ClaimModel, IClaim } from '../../shared/models';
import { Store } from '@ngrx/store';
import { CLAIMS_SELECT } from '../store/selectors/claims.selector';
import { EClaimOperation, EClaimsGroup, TApplicationClaimMapKey } from '../configurations/claims.config';
import { ROOT_ROUTES } from '../configurations/router.config';
import { arrayOfType } from '../../shared/utils/data.utils';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {
  constructor(
    private readonly http: HttpClient,
    private readonly store: Store,
  ) {}

  getClaims(): Observable<ClaimModel[]> {
    return this.http.get<IClaim[]>('/api/authorization/GetClaims').pipe(
      retry(1),
      map((claims: IClaim[]) => arrayOfType<ClaimModel>(claims, ClaimModel)),
    );
  }

  hasApplicationReadClaims(claimMapKey: TApplicationClaimMapKey | null): Observable<boolean> {
    return CLAIMS_SELECT.applicationClaimsByMapKey(this.store, claimMapKey).pipe(
      map((claims) => claims.some((claim) => claim.endsWith(EClaimOperation.read))),
    );
  }

  isGroupHasReadClaims(claim: EClaimsGroup): Observable<boolean> {
    return CLAIMS_SELECT.claimsByGroupName(this.store, claim).pipe(
      map((claims) => claims.some((claim) => claim.endsWith(EClaimOperation.read))),
    );
  }

  hasPageClaim(claim: string): Observable<boolean> {
    return CLAIMS_SELECT.retrievedClaims(this.store).pipe(map((claims) => claims.includes(claim)));
  }

  getApplicationMapKeyFromURL(url: string): TApplicationClaimMapKey | null {
    if (url.includes(ROOT_ROUTES.dashboard)) {
      return 'dashboard';
    }

    if (url.includes(ROOT_ROUTES.reporting)) {
      return 'reporting';
    }

    if (url.includes(ROOT_ROUTES.admin)) {
      return 'admin';
    }

    if (url.includes(ROOT_ROUTES.calendar)) {
      return 'calendar';
    }

    if (url.includes(ROOT_ROUTES.aceInsights)) {
      return 'aceInsights';
    }

    if (url.includes(ROOT_ROUTES.aiAssistant)) {
      return 'aiAssistant';
    }

    return null;
  }
}
